import TopPage from './TopPage/TopPage';
import SignIn from './common/SignIn/SignIn';
import Download from './Download/Download';
import ChowaApp from './clients/chowa/ChowaApp';
import KskApp from './clients/ksk/KskApp';
import PrivateRoute from './common/components/PrivateRoute';
import Ns6989App from './clients/ns/ns6989/Ns6989App';
import JpCfdDownload from './myURL/JpCfdDownload';

const routes = [
  //KSK Cloud基本機能
  {
    path: '/',
    element: <TopPage />,
    title: 'ホーム'
  },
  {
    path: '/download',
    element: <Download />,
    title: 'ダウンロード'
  },
  {
    path: '/signin',
    element: <SignIn />,
    title: 'サインイン'
  },

  //ログイン後のユーザー別
  {
    path: '/chowa/*',
    element: (
      <PrivateRoute authType="chowa">
        <ChowaApp />
      </PrivateRoute>
    ),
    title: 'Chowa Dashboard'
  },
  {
    path: '/ksk/*',
    element: (
      <PrivateRoute authType="ksk">
        <KskApp />
      </PrivateRoute>
    ),
    title: 'KSK Dashboard'
  },
  {
    path: '/ns6989/*',
    element: (
      <PrivateRoute authType="ns6989">
        <Ns6989App />
      </PrivateRoute>
    ),
    title: 'NS6989 Dashboard'
  },
  // JP CFD ダウンロード専用ページ
  {
    path: '/jpcfd',
    element: <JpCfdDownload />,
    title: 'JP CFD データダウンロード'
  }
];

export default routes;